import { render, staticRenderFns } from "./FooterGallery.vue?vue&type=template&id=59a6a026&scoped=true"
import script from "./FooterGallery.vue?vue&type=script&lang=js"
export * from "./FooterGallery.vue?vue&type=script&lang=js"
import style0 from "./FooterGallery.vue?vue&type=style&index=0&id=59a6a026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a6a026",
  null
  
)

export default component.exports